<template>
  <el-dialog :title="$t('addMerchantShop.add')" :visible.sync="dialogVisible" width="70%" @close="handleClose">
    <el-form ref="form" :model="addMerchantShopInfo" label-width="120px">
      <el-form-item :label="$t('addMerchantShop.companyName')" prop="name">
        <el-input v-model="addMerchantShopInfo.name" :placeholder="$t('addMerchantShop.requiredCompanyName')" />
      </el-form-item>

      <el-form-item :label="$t('addMerchantShop.shopType')" prop="shopType">
        <el-select v-model="addMerchantShopInfo.shopType" :placeholder="$t('addMerchantShop.selectShopType')"
          style="width:100%">
          <el-option v-for="item in addMerchantShopInfo.shopTypes" :key="item.shopTypeId" :label="item.typeName"
            :value="item.shopTypeId" />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('addMerchantShop.shopArea')">
        <el-row :gutter="10">
          <el-col :span="6">
            <el-select v-model="addMerchantShopInfo.selectProv" :placeholder="$t('addMerchantShop.selectProvince')"
              @change="getProv" style="width:100%">
              <el-option v-for="item in addMerchantShopInfo.provs" :key="item.areaCode" :label="item.areaName"
                :value="item.areaCode" />
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-select v-model="addMerchantShopInfo.selectCity" :placeholder="$t('addMerchantShop.selectCity')"
              @change="getCity" style="width:100%" :disabled="!addMerchantShopInfo.selectProv">
              <el-option v-for="item in addMerchantShopInfo.citys" :key="item.areaCode" :label="item.areaName"
                :value="item.areaCode" />
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-select v-model="addMerchantShopInfo.selectArea" :placeholder="$t('addMerchantShop.selectDistrict')"
              @change="getArea" style="width:100%" :disabled="!addMerchantShopInfo.selectCity">
              <el-option v-for="item in addMerchantShopInfo.areas" :key="item.areaCode" :label="item.areaName"
                :value="item.areaCode" />
            </el-select>
          </el-col>
        </el-row>
      </el-form-item>

      <el-form-item :label="$t('addMerchantShop.shopName')" prop="shopName">
        <el-input v-model="addMerchantShopInfo.shopName" :placeholder="$t('addMerchantShop.requiredShopName')" />
      </el-form-item>

      <el-form-item :label="$t('addMerchantShop.address')" prop="address">
        <el-input v-model="addMerchantShopInfo.address" :placeholder="$t('addMerchantShop.requiredAddress')" />
      </el-form-item>

      <el-form-item :label="$t('addMerchantShop.tel')" prop="tel">
        <el-input v-model="addMerchantShopInfo.tel" :placeholder="$t('addMerchantShop.requiredTel')" />
      </el-form-item>

      <el-alert :title="$t('addMerchantShop.tips')" type="info" show-icon :closable="false" />
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="saveMerchantShopInfo">
        {{ $t('common.save') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { listAreas, queryShopType, adminAddStoreAndShop } from '@/api/admin/addMerchantShop/addMerchantShopApi'

export default {
  name: 'AddMerchantShop',
  data() {
    return {
      dialogVisible: false,
      addMerchantShopInfo: {
        name: '',
        shopName: '',
        address: '',
        tel: '',
        storeTypeCd: '800900000005',
        nearbyLandmarks: '无',
        areaCode: '',
        shopType: '',
        shopTypes: [],
        areas: [],
        provs: [],
        citys: [],
        selectProv: '',
        selectCity: '',
        selectArea: ''
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this._initArea('101', '0')
      this._listShopTypes()
    },
    handleClose() {
      this.$refs.form.resetFields()
      this.addMerchantShopInfo = {
        name: '',
        shopName: '',
        address: '',
        tel: '',
        storeTypeCd: '800900000005',
        nearbyLandmarks: '无',
        areaCode: '',
        shopType: '',
        shopTypes: [],
        areas: [],
        provs: [],
        citys: [],
        selectProv: '',
        selectCity: '',
        selectArea: ''
      }
    },
    async saveMerchantShopInfo() {
      try {
        const res = await adminAddStoreAndShop(this.addMerchantShopInfo)
        this.$message.success(res.msg)
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error(error)
      }
    },
    getProv(prov) {
      this._initArea('202', prov)
    },
    getCity(city) {
      this._initArea('303', city)
    },
    getArea(area) {
      this.addMerchantShopInfo.areaCode = area
      this.addMerchantShopInfo.areaAddress = ''

      const prov = this.addMerchantShopInfo.provs.find(
        item => item.areaCode === this.addMerchantShopInfo.selectProv
      )
      if (prov) this.addMerchantShopInfo.areaAddress += prov.areaName

      const city = this.addMerchantShopInfo.citys.find(
        item => item.areaCode === this.addMerchantShopInfo.selectCity
      )
      if (city) this.addMerchantShopInfo.areaAddress += city.areaName

      const areaObj = this.addMerchantShopInfo.areas.find(
        item => item.areaCode === this.addMerchantShopInfo.selectArea
      )
      if (areaObj) this.addMerchantShopInfo.areaAddress += areaObj.areaName
    },
    async _initArea(areaLevel, parentAreaCode) {
      try {
        const res = await listAreas({ areaLevel, parentAreaCode })
        if (areaLevel === '101') {
          this.addMerchantShopInfo.provs = res.data
        } else if (areaLevel === '202') {
          this.addMerchantShopInfo.citys = res.data
        } else {
          this.addMerchantShopInfo.areas = res.data
        }
      } catch (error) {
        console.error(error)
        this.$message.error(this.$t('addMerchantShop.getAreaFailed'))
      }
    },
    async _listShopTypes() {
      try {
        const res = await queryShopType({ page: 1, row: 100 })
        this.addMerchantShopInfo.shopTypes = res.data
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>